import React from "react";
import { BrowserRouter, Route } from "react-router-dom";

import CarsView from "./Views/CarsView";
import ClientsView from "./Views/ClientsView";
import MenuAppBar from "./layout/MenuAppBar";

export default function() {
  return (
    <React.Fragment>
      <BrowserRouter>
      <MenuAppBar />
        <Route
          path="/rent/"
          exact
          render={() => {
            return (
              <section className="main-view-wrapper">
                <div className="calendar-wrapper">
                  {" "}
                  <CarsView />
                </div>
              </section>
            );
          }}
        />
        <Route
          path="/rent/clients"
          exact
          render={() => {
            return (
              <section className="main-view-wrapper">
                <ClientsView />
              </section>
            );
          }}
        />
      </BrowserRouter>
    </React.Fragment>
  );
}
